import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Theme } from '@yuno/design-system-web'

type ConnectionSetupInstructionContainerProps = {
  instructionType: string
  children?: JSX.Element | Array<JSX.Element>
  credentials?: boolean
}

type StyledProps = { theme?: Theme; styles?: React.CSSProperties }

const TitleStyle = ({ theme }: StyledProps) => css`
  color: ${theme.palette.neutral.black};
  font-size: ${theme.typography.tiny.regular.fontSize};
  font-family: ${theme.typography.tiny.regular.fontFamily};
  font-weight: ${theme.typography.tiny.regular.fontWeight};
  line-height: ${theme.typography.tiny.regular.lineHeight};
  margin-bottom: 20px;
`

const TitleDiv = styled('div')<StyledProps>`
  ${({ theme }) => TitleStyle({ theme })}
`

const TitleUl = styled('ul')<StyledProps>`
  ${({ theme }) => TitleStyle({ theme })}
  margin-left: -18px;
`

const TitleOl = styled('ol')<StyledProps>`
  ${({ theme }) => TitleStyle({ theme })}
  margin-left: -18px;
`

const TitleStyleCredentialsInstructions = ({ theme }: StyledProps) => css`
  color: ${theme.palette.vivid.brand};
  font-size: ${theme.typography.tiny.regular.fontSize};
  font-family: ${theme.typography.tiny.regular.fontFamily};
  font-weight: ${theme.typography.tiny.regular.fontWeight};
  line-height: ${theme.typography.tiny.regular.lineHeight};
`

const TitleDivCredentials = styled('ul')<StyledProps>`
  ${({ theme }) => TitleStyleCredentialsInstructions({ theme })}
  margin: 0;
  padding-left: 18px;
`

const TitleUlCredentials = styled('ul')<StyledProps>`
  ${({ theme }) => TitleStyleCredentialsInstructions({ theme })}
  margin-left: -18px;
`

const TitleOlCredentials = styled('ol')<StyledProps>`
  ${({ theme }) => TitleStyleCredentialsInstructions({ theme })}
  margin-left: -18px;
`

export const ConnectionSetupInstructionContainer = ({
  instructionType,
  children,
  credentials,
}: ConnectionSetupInstructionContainerProps) => {
  if (credentials) {
    if (instructionType === 'POINT') {
      return <TitleUlCredentials>{children}</TitleUlCredentials>
    }

    if (instructionType === 'NUMBER') {
      return <TitleOlCredentials>{children}</TitleOlCredentials>
    }

    return <TitleDivCredentials>{children}</TitleDivCredentials>
  }
  if (instructionType === 'POINT') {
    return <TitleUl>{children}</TitleUl>
  }

  if (instructionType === 'NUMBER') {
    return <TitleOl>{children}</TitleOl>
  }

  return <TitleDiv>{children}</TitleDiv>
}
